import React from "react";
import { DataProvider } from "./components/context";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Index from "./layout/Index";
import Register from "./layout/Register";
import Profile from "./layout/Profile";
import Login from "./layout/Login";
import Complaints from "./layout/Complaints";
import Users from "./layout/Users";
import PrivateRoute from "./privateRoute/privateRoute";
import PageNotFound from "./pageNotFound";
import Analytics from "./layout/Analytics";
export const endpoint = "https://hcms-backend-wmdp.onrender.com/api/";

function App() {
  return (
    <div className="App">
      <Router>
        <DataProvider>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/register" element={<Register />} />
            {/* These routes are accessible only to logged-in users */}
            <Route
              exact
              path="/index"
              element={<PrivateRoute Component={Index} />}
            />
            <Route
              exact
              path="/profile"
              element={<PrivateRoute Component={Profile} />}
            />
            <Route
              exact
              path="/complaints"
              element={<PrivateRoute Component={Complaints} />}
            />
            <Route
              exact
              path="/users"
              element={<PrivateRoute Component={Users} />}
            />
            <Route
              exact
              path="/analytics"
              element={<PrivateRoute Component={Analytics} />}
            />
            <Route
              exact
              path="*"
              element={<PrivateRoute Component={PageNotFound} />}
            />
          </Routes>
        </DataProvider>
      </Router>
    </div>
  );
}

export default App;
